import { render, staticRenderFns } from "./UninstallScreen.vue?vue&type=template&id=a9b787be&scoped=true"
import script from "./UninstallScreen.vue?vue&type=script&lang=js"
export * from "./UninstallScreen.vue?vue&type=script&lang=js"
import style0 from "./UninstallScreen.vue?vue&type=style&index=0&id=a9b787be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b787be",
  null
  
)

export default component.exports